export enum BuckarooStatus {
	SUCCESS,
	FAILED,
	PENDING,
	REJECTED,
	CANCELLED,
}
